/* eslint-disable no-unused-vars */

enum permissionStatusEnum {
  Default = 'default',
  Granted = 'granted',
  Denied = 'denied',
}

export default permissionStatusEnum;
